import { Fragment } from 'react'

/**
 * 텍스트 내 URL(http/https)을 자동으로 클릭 가능한 링크로 변환하는 컴포넌트.
 * 체험단 미션 가이드 등 plain text에 포함된 URL을 하이퍼링크로 표시할 때 사용.
 */
export function Linkify({ children }: { children: string }) {
  const urlRegex = /(https?:\/\/[^\s]+)/g
  const parts = children.split(urlRegex)

  return (
    <>
      {parts.map((part, i) =>
        urlRegex.test(part) ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline break-all"
          >
            {part}
          </a>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        )
      )}
    </>
  )
}
